import { Box, IconButton, Modal, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MapScreen from "./MapScreen";
import Addproject from "./Addproject";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setSelectedSiteId, setShowmapmodal } from "../../redux/actions/actions";
import { English } from "../../constant/EnglishFallback";
import { useLocation, useNavigate } from "react-router-dom";

export default function Mapmodal() {
  const { showMapmodal, multiLanguageData } = useSelector((state) => state?.main);
  const dispatch = useDispatch();
  const navLocation = useLocation();
  const navigate = useNavigate();
  const {
    TEXT_SELECT_LOCATION = English?.MapModal?.TEXT_SELECT_LOCATION,
    TEXT_CHOOSE_PROJECTS = English?.MapModal?.TEXT_CHOOSE_PROJECTS,
    TEXT_CHOOSE_SITE_ON_MAP = English?.MapModal?.TEXT_CHOOSE_SITE_ON_MAP,
    TEXT_MAP = English?.MapModal?.TEXT_MAP
  } = multiLanguageData?.MapModal || {};

  const onClosemapmodal = () => {
    let mapModal = {
      open: false,
      from: "",
      select: ""
    };
    // Below code comment it not to uncomment -- Because it will reset the map location selected site and selected project data from Communithome
    // We use Reset for cleanup code for Questions
    // dispatch(
    //   setSelectlocation({
    //     open: false,
    //     lat: 0,
    //     lng: 0
    //   })
    // );
    // dispatch(setSelectedsite(null));
    // dispatch(setSelectedProjectdata(null));
    dispatch(setShowmapmodal(mapModal));
    dispatch(setSelectedSiteId(0));
    if (navLocation?.state) navigate("/home", { replace: true, state: null });
  };

  const validValues = [
    "experience",
    "company-detail",
    "product-detail",
    "manufacture-detail",
    "earn-rewards"
  ];

  return (
    <Box>
      <Modal open={showMapmodal?.open}>
        <Box
          className="user-modal-responsive2"
          sx={{
            width: {
              xs: '90%',
              md: '90%'
            }
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            <Typography variant="h6">
              {showMapmodal?.from === "choose-location"
                ? TEXT_SELECT_LOCATION
                : validValues.includes(showMapmodal?.from) && showMapmodal?.select === "project"
                  ? TEXT_CHOOSE_PROJECTS
                  : validValues.includes(showMapmodal?.from) && showMapmodal?.select === "site" || showMapmodal?.select === "add-site"
                    ? TEXT_CHOOSE_SITE_ON_MAP
                    : TEXT_MAP}
            </Typography>
            <Stack>
              <IconButton onClick={onClosemapmodal}>
                <CloseIcon />
              </IconButton>
            </Stack>
          </Box>
          <Box>
            <MapScreen showNavigation={showMapmodal?.select === "add-site" ? true : false} modal={true} />
          </Box>
        </Box>
      </Modal>
      <Addproject />
    </Box>
  );
}
